import { gql, useMutation } from '@apollo/client'

const ACCEPT_TERMS = gql`
  mutation UseAcceptTerms($consent: Boolean) {
    consentToTerms(consent: $consent) {
      ok
    }
  }
`

const CONSENT_TO_TERMS_QUERY = gql`
  query ConsentToTerms {
    account {
      id
      consentToTerms
    }
  }
`

export const useAcceptTerms = (options = {}) => {
  return useMutation(ACCEPT_TERMS, {
    ...options,
    refetchQueries: [{ query: CONSENT_TO_TERMS_QUERY }],
  })
}
